export default "है\nया\nकहाँ\nक्या\nकैसे\nकितने\nकितना\nचाहिए\nकर सकना"